import { ProfileProps } from './profile.types'
import { HeaderProfile } from '@touche-lts/panel-ui/dist'
import { User } from 'services'
import { IconLogout } from 'assets/icons'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import cl from 'classnames'
import styles from './profile.module.scss'

const ProfileComponent = (props: ProfileProps) => {
  const { className, style } = props
  const {
    routingStore: { push }
  } = useRootStore()

  return (
    <HeaderProfile
      className={cl(styles.profileContainer, className)}
      style={style}
      isUserAuthenticated={User.isAuthenticated}
      user={{ name: User.fullName, image: User.imageUrl }}
      profileMenu={[
        {
          icon: IconLogout,
          label: 'Log out',
          onClick: () => {
            User.deauthenticate()
            push('/shopify/login')
          }
        }
      ]}
    />
  )
}

const Profile = observer(ProfileComponent)
export { Profile }
